import { MarketingShell } from "@/components/landing/MarketingShell";
import { useSession } from "@/components/useSession";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { LandingPage2 } from "@/components/landing2";
import { LandingPage } from "@/components/landing";

function Page() {
  const router = useRouter();
  const { status } = useSession();
  const [stay, setStay] = useState<boolean | undefined>(undefined);
  const [vibe, setVibe] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    if (typeof window !== "undefined") {
      setVibe(
        window.document.location.hash === "#vibe" ||
          window.document.location.search.includes("vibe") ||
          // Also from ads
          window.document.location.search.includes("fbclid") ||
          window.document.location.search.includes("gclid") ||
          // From campaigns
          window.document.location.search.includes("utm_source=facebook") ||
          window.document.location.search.includes("utm_source=google")
      );
    }

    if (typeof window !== "undefined") {
      setStay(window.document.location.hash === "#stay");
    }
  }, []);

  if (stay === false && vibe === false) {
    if (status === "authenticated") {
      router.push("/dashboard", undefined, { shallow: true });
      return;
    }
  }

  return (
    <MarketingShell className="flex flex-col justify-center" themeToggle={false}>
      {vibe ? <LandingPage2 /> : <LandingPage />}
    </MarketingShell>
  );
}

export default Page;
